// <s-sticky-atc> reveals a mobile add-to-cart bar once the main add-to-cart
// button (data-main-atc, matched inside the same product form region) leaves the viewport.
class SStickyAtc extends HTMLElement {
  #observer;

  connectedCallback() {
    const scope = this.closest('[data-product-form]') ?? document;
    const target = scope.querySelector('[data-main-atc]');
    if (!target) return;
    this.#observer = new IntersectionObserver(
      ([entry]) => {
        const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.toggleAttribute('data-visible', passed);
      },
      { threshold: 0 }
    );
    this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('s-sticky-atc')) customElements.define('s-sticky-atc', SStickyAtc);
